import axios from "axios"

export const myAxios = axios.create({
  baseURL: process.env.REACT_APP_AXIOS+'/dashboard',
  timeout: 1000 * 60 * 2,
})
